import { Box, useCircleSize, useLayoutContext } from "arkh";
import React from "react";

export function GroupItemLine(props: {
  paddingLeft?: number;
  isLast?: boolean;
  color?: string | undefined | null;
}) {
  const circleSize = useCircleSize("smallMedium");
  const layout = useLayoutContext();
  const paddingLeft =
    props.paddingLeft !== undefined ? props.paddingLeft : layout.space.medium;
  return (
    <Box
      style={{
        width: circleSize + paddingLeft,
        paddingLeft,
        paddingBottom: props.isLast ? layout.space.small : 0,
        flexDirection: "row",
        justifyContent: "center",
      }}
    >
      <Box
        style={{
          width: 2,
          height: "100%",
          backgroundColor: props.color ?? "transparent",
        }}
        color="border-primary"
      />
    </Box>
  );
}
